<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.4375 8H14.5625" stroke="#57B8D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 1.4375V14.5625" stroke="#57B8D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
    name:"PlusIcon"
    }
</script>
